function toISO(dateObject) {
  let str = '';

  if (typeof dateObject === 'string') {
    const dts = dateObject.split(/[ T]/);
    const dmy = dts[0].split(/[-\/]/);

    if (parseInt(dmy[0]) > 31) {
      str = getISOYear(dmy[0]) + '-' + ('0' + dmy[1]).substr(-2) + '-' + ('0' + dmy[2]).substr(-2);
    } else {
      str = getISOYear(dmy[2]) + '-' + ('0' + dmy[1]).substr(-2) + '-' + ('0' + dmy[0]).substr(-2);
    }

    if (dts[1]) {
      str += dts[1];
    }
  } else {
    str =
      dateObject.getFullYear() +
      '-' +
      ('0' + (dateObject.getMonth() + 1)).substr(-2) +
      '-' +
      ('0' + dateObject.getDate()).substr(-2);
  }

  return str;
}

function getISOYear(year) {
  const today = new Date();
  const thisYear = today.getFullYear();

  year = parseInt(year);
  if (year > thisYear + 250) {
    return year - 543;
  } else {
    return year;
  }
}

function getThaiYear(year) {
  const today = new Date();
  const thisYear = today.getFullYear();

  year = parseInt(year);
  if (year > thisYear + 250) {
    return year;
  } else {
    return year + 543;
  }
}

function toThaiDMY(dateObject) {
  if (typeof dateObject === 'undefined') return null;
  if (dateObject == null) return null;

  let str = '';

  if (typeof dateObject === 'string') {
    const dts = dateObject.split(/[ T]/);
    const dmy = dts[0].split(/[-\/]/);

    if (parseInt(dmy[0]) > 31) {
      str = dmy[2] + '/' + dmy[1] + '/' + getThaiYear(dmy[0]);
    } else {
      str = dmy[0] + '/' + dmy[1] + '/' + getThaiYear(dmy[2]);
    }

    if (dts[1]) {
      str += dts[1];
    }
  } else {
    str = dateObject.getDate() + '/' + (dateObject.getMonth() + 1) + '/' + (dateObject.getFullYear() + 543);
  }

  return str;
}

module.exports = {
  toISO,
  toThaiDMY,
};
